import { render, staticRenderFns } from "./miniWeek.vue?vue&type=template&id=cf886216&"
import script from "./miniWeek.vue?vue&type=script&lang=js&"
export * from "./miniWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports